export const SQUARES_TERMS_OF_SERVICE_URL =
  'https://dknetwork.draftkings.com/sweepstakes/3-30-2026-big-league-draw-promotion-official-rules/';

/**
 * String-level replacement of any href pointing at /terms or shortlinks.
 */
export function fixTermsLinksInHtml(html: string): string {
  // Catch href="/terms", href='/terms', href="http://dkng.co/bigleaguedrawterms", etc.
  return html
    .replace(/href\s*=\s*["']\/terms\/?["']/gi, `href="${SQUARES_TERMS_OF_SERVICE_URL}"`)
    .replace(/href\s*=\s*["']terms\/?["']/gi, `href="${SQUARES_TERMS_OF_SERVICE_URL}"`)
    .replace(
      /href\s*=\s*["'][^"']*bigleaguedrawterms[^"']*["']/gi,
      `href="${SQUARES_TERMS_OF_SERVICE_URL}"`
    )
    .replace(
      /href\s*=\s*["'][^"']*dkng\.co\/bigleague[^"']*["']/gi,
      `href="${SQUARES_TERMS_OF_SERVICE_URL}"`
    )
    .replace(
      /href\s*=\s*["'][^"']*3-30-2026-big-league-draw-promotion-official-rules[^"']*["']/gi,
      `href="${SQUARES_TERMS_OF_SERVICE_URL}"`
    );
}

/**
 * Click handler for the rules HTML container.
 * Intercepts clicks on any <a> that resolves to /terms (regardless of how the href is written)
 * and forces a real navigation to the official rules page.
 */
export function handleTermsClick(e: React.MouseEvent<HTMLDivElement>): void {
  const target = e.target as HTMLElement;
  const anchor = target.tagName === 'A' ? (target as HTMLAnchorElement) : target.closest?.('a');
  if (!anchor) return;

  // anchor.href is the RESOLVED absolute URL the browser would actually navigate to.
  // This catches /terms, ./terms, terms, etc. no matter how the relative path was written.
  const resolved = anchor.href; // e.g. "http://localhost:8082/terms"
  const raw = (anchor.getAttribute('href') ?? '').trim().toLowerCase();

  const isBrokenTermsLink =
    resolved.endsWith('/terms') ||
    resolved.endsWith('/terms/') ||
    resolved.includes('/terms?') ||
    resolved.includes('/terms#') ||
    raw.includes('bigleaguedrawterms') ||
    raw.includes('dkng.co/bigleague');

  if (isBrokenTermsLink) {
    e.preventDefault();
    e.stopPropagation();
    window.location.href = SQUARES_TERMS_OF_SERVICE_URL;
  }
}
